import styled from 'styled-components'

export const StyledSplit = styled.div`
  display: flex;
  align-items: center;
  padding: 50px 0;
`

export const Content = styled.div`
  display: flex;
  gap: 25px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    flex-direction: column-reverse;
  }
`

export const ImageSection = styled.div`
  width: 60%;
  text-align: center;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    width: 100%;
    position: relative;
    z-index: 1;
  }
`

export const Image = styled.img`
  max-width: 100%;
  max-height: 500px;
`

export const TextSection = styled.div`
  width: 40%;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    width: 100%;
  }
`

export const Headline = styled.div`
  font-size: ${({ theme }) => theme.font.size.xlg};
  font-family: 'bold';
`

export const Subheadline = styled.div`
  font-size: ${({ theme }) => theme.font.size.xlg};
`

export const Text = styled.div`
  font-size: ${({ theme }) => theme.font.size.sm};
  text-align: justify;
  margin-top: 25px;
  * {
    font-size: ${({ theme }) => theme.font.size.sm};
  }
`

export const CTAWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const CTA = styled.a`
  color: ${({ theme }) => theme.color.font.secondary};
  background-color: ${({ theme }) => theme.color.background.blue};
  font-size: ${({ theme }) => theme.font.size.sm};
  border-radius: 30px;
  padding: 10px 20px;
  display: inline-block;
  margin: 25px auto;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
`
